import React from "react";
import clsx from "clsx";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import { TransitionProps } from "@material-ui/core/transitions";

import Loader from "components/Loader";
import useStyles from "./styles";

export interface Props {
  onSave?: () => void;
  onCancel: () => void;
  onDiscard: () => void;
  open: boolean;
  title?: string;
  cancelButtonLabel?: string;
  saveButtonLabel?: string;
  content?: React.ReactElement;
  isSaveDisabled?: boolean;
  isLoading?: boolean;
  TransitionProps?: TransitionProps;
  className?: string;
  disallowClosePopupOutside?: boolean;
}

const UnsavedChangesDialog = (props: Props) => {
  const {
    onSave,
    onCancel,
    onDiscard,
    open,
    title,
    cancelButtonLabel,
    saveButtonLabel,
    content,
    isSaveDisabled,
    isLoading,
    TransitionProps = {},
    className,
    disallowClosePopupOutside
  } = props;
  const classes = useStyles();

  const handleSave = () => {
    onSave?.();
  };

  const handleCancel = () => {
    onCancel();
  };

  const handleDiscard = () => {
    onDiscard();
  };

  return (
    <Dialog
      open={open}
      onClose={disallowClosePopupOutside ? null : onCancel}
      className={clsx(classes.confirmationDialog, className)}
      TransitionProps={TransitionProps}
    >
      <DialogTitle>
        <Typography className={classes.dialogTitleTypography}>
          {title ? title : "Unsaved Changes"}
        </Typography>
      </DialogTitle>
      <DialogContent>
        {isLoading && <Loader overlay />}
        <Typography className={classes.dialogContentText}>
          {content
            ? content
            : "What would you like to do with your unsaved changes?"}
        </Typography>
      </DialogContent>
      <DialogActions>
        {!isSaveDisabled && (
          <Button
            className={clsx(classes.button, classes.cancel)}
            onClick={handleCancel}
            color="primary"
          >
            {cancelButtonLabel || "Cancel"}
          </Button>
        )}
        <div className={classes.decisions}>
          <Button
            className={clsx(classes.button, classes.negative)}
            onClick={handleDiscard}
          >
            Discard
          </Button>
          {onSave && (
            <>
              {isSaveDisabled ? (
                <Button
                  className={clsx(classes.button, classes.positive)}
                  onClick={handleCancel}
                >
                  Stay and Continue
                </Button>
              ) : (
                <Button
                  className={clsx(classes.button, classes.positive)}
                  onClick={handleSave}
                >
                  {saveButtonLabel || "Save Changes"}
                </Button>
              )}
            </>
          )}
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default UnsavedChangesDialog;
